import { Button } from "antd";
import React, { useState, useRef, useEffect } from "react";
import "./style.scss";
import PageDescription from "../common/pageDescription";
import RootCauseTable from "../../../views/internal/shared/dashboard/components/AiDashboardComponents/rootCauseTable";
import { useHistory } from "react-router-dom";
import { DashboardApi } from "../../../core/api/dashboardApi";
import CustomModal from "../customModal";
import { dashboardRoute } from "../../../core/constants/routesPath";
const PreAnalysisQuestions = ({ sessionId }) => {
    const [selectedReason, setSelectedReason] = useState([]);
    const [selectedRadio, setSelectedRadio] = useState(""); // "yes" or "no"
    const [AIData, setAIData] = useState(null);
    const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false);
    const [formDataVersion, setFormDataVersion] = useState(0);
    const history = useHistory();
    useEffect(() => {
        DashboardApi.getAIPreAnalysisResponse(sessionId, true).then((response) => {
            setAIData(response);
            if ((response === null || response === void 0 ? void 0 : response.code) === "PRE_ANALYSIS_ALREADY_SUBMITTED") {
                history.push(dashboardRoute);
            }
        });
    }, [sessionId]);
    const tableRef = useRef(null);
    const hasApiError = () => {
        return ((AIData === null || AIData === void 0 ? void 0 : AIData.code) === "-1" || (AIData === null || AIData === void 0 ? void 0 : AIData.code) === "PRE_ANALYSIS_ALREADY_SUBMITTED");
    };
    const isFormValid = () => {
        var _a, _b;
        if (!tableRef.current) {
            return false;
        }
        const tableData = ((_b = (_a = tableRef.current).getTableData) === null || _b === void 0 ? void 0 : _b.call(_a)) || [];
        if (!tableData || tableData.length === 0) {
            return false;
        }
        const validationResults = tableData.map((item) => {
            const isValid = item.requireReview && item.requireReview.trim() !== "";
            return isValid;
        });
        const allValid = validationResults.every((result) => result);
        return allValid;
    };
    const getButtonText = () => {
        if (hasBeenSubmitted)
            return "Analysis Submitted";
        if (isSubmitting)
            return "Submitting...";
        if (hasApiError())
            return "Submit Analysis";
        return "Submit Analysis";
    };
    const handleSubmitAnalysis = () => {
        var _a, _b;
        setHasBeenSubmitted(true);
        setIsSubmitModalVisible(true);
        setIsSubmitting(true);
        const tableData = ((_b = (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.getTableData) === null || _b === void 0 ? void 0 : _b.call(_a)) || [];
        const payload = tableData.map((item) => {
            const isNoReview = item.requireReview === "No" ||
                item.requireReview === "No Explanation available";
            return {
                id: item.id,
                reasons: isNoReview ? [] : item.selectedReasons || [],
                requireReview: item.requireReview || "",
                otherReason: isNoReview ? "" : item.otherReason || "",
                rootCause: item.rootCause || "",
                direction: item.direction || "",
                varianceMateriality: item.varianceMateriality || "",
                period: item.period || "",
                code: item.code || "",
            };
        });
        // Submit the analysis
        DashboardApi.getAIPreAnalysisSubmit(sessionId, payload, true)
            .then((response) => {
            setIsSubmitting(false);
            setIsSubmitting(false);
        })
            .catch((error) => {
            setIsSubmitting(false);
        });
        history.push(dashboardRoute);
    };
    const handleModalClose = () => {
        setIsSubmitModalVisible(false);
    };
    const triggerFormValidation = () => {
        setTimeout(() => {
            setFormDataVersion((prev) => prev + 1);
        }, 0);
    };
    return (React.createElement("div", { className: "pre-analysis-container" },
        React.createElement("div", { className: "pre-analysis-header" }, "Pre-Analysis Questions"),
        React.createElement(PageDescription, { description: ": we've observed some high material changes in the reported values of assets/liabilities/revenue for the current month. To ensure we have a clear understanding of these movements and their implications, we would appreciate your insights on the below", title: ["Note"], isLoading: false, customDescriptionStyle: { padding: "15px 15px" } }),
        React.createElement("div", { className: "pre-analysis-content" },
            React.createElement(RootCauseTable, { ref: tableRef, preAnalysis: true, data: AIData || [], setAIData: setAIData, onFormDataChange: triggerFormValidation })),
        React.createElement("div", { className: "pre-analysis-footer" },
            React.createElement(Button, { type: "primary", style: {}, onClick: handleSubmitAnalysis, loading: isSubmitting, disabled: isSubmitting || hasBeenSubmitted || hasApiError() || !isFormValid() }, getButtonText())),
        React.createElement(CustomModal, { visible: isSubmitModalVisible, onCancel: handleModalClose, maskClosable: true, destroyOnClose: true, footer: null, width: "400px" },
            React.createElement("div", { style: { padding: "20px", textAlign: "center" } },
                React.createElement("div", { style: { marginBottom: "20px" } },
                    React.createElement("h3", { style: { color: "#2c3e50", marginBottom: "10px" } }, isSubmitting ? "Submitting Analysis..." : "Analysis Submitted"),
                    React.createElement("p", { style: { color: "#666", fontSize: "14px", lineHeight: "1.5" } }, isSubmitting
                        ? "Your pre-analysis answers are being submitted. Please wait while we process your responses."
                        : "Your pre-analysis answers have been successfully submitted. Thank you for your input.")),
                isSubmitting && (React.createElement("div", { style: {
                        backgroundColor: "#f8f9fa",
                        padding: "15px",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                    } },
                    React.createElement("p", { style: {
                            color: "#495057",
                            fontSize: "13px",
                            margin: 0,
                            fontStyle: "italic",
                        } }, "\uD83D\uDCA1 This process typically takes a few seconds."))),
                !isSubmitting && (React.createElement("div", { style: { marginTop: "20px" } },
                    React.createElement(Button, { type: "primary", onClick: handleModalClose, style: { minWidth: "100px" } }, "Close")))))));
};
export default PreAnalysisQuestions;
